import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getUserListUrl, GET_USER_LIST_ACTION_TYPE, getUserDetailsUrl, GET_USER_DETAILS_ACTION_TYPE, addUpdateUserUrl, ADD_UPDATE_USER_ACTION_TYPE, deleteUserUrl, DELETE_USER_ACTION_TYPE, headers, suspendUserUrl, SUSPEND_USER_ACTION_TYPE } from "../../utils/constants"
import moment from 'moment';

export const get_userList_action = (name, email_address, contact_no, designation,role_id,is_active) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: sessionStorage.getItem('user_id') != '' && sessionStorage.getItem('user_id') != null ? sessionStorage.getItem('user_id') : null,
            name: name != '' ? name : null,
            email_address: email_address != '' ? email_address : null,
            contact_no: contact_no != '' ? contact_no : null,
            designation: designation != '' ? designation : null,
            role_id: role_id != '' ? role_id : null,
            is_active:is_active
        }
        const res = await axiosGet(getUserListUrl, mapdata,headers);

        dispatch({
            type: GET_USER_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_userDetails_action = (user_id) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: user_id
        }
        const res = await axiosGet(getUserDetailsUrl, mapdata,headers);
        dispatch({
            type: GET_USER_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const addUpdate_user_action = ( user_id,
    userName,
    email,
    phone,
    designation,
    roleId) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: user_id != '' ? user_id : null,
            name: userName,
            email_address: email,
            contact_no: phone,
            designation: designation,
            role_id: roleId != '' ? roleId : null,
            created_by_id: parseInt(sessionStorage.getItem('user_id')),
            created_by_user: sessionStorage.getItem('user_name')
        }
        const res = await axiosPost(addUpdateUserUrl, mapdata, headers);

        dispatch({
            type: ADD_UPDATE_USER_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const deleteUser_action = (user_id) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: user_id,
            deleted_by_id: parseInt(sessionStorage.getItem('user_id')),
            deleted_by_user: sessionStorage.getItem('user_name')
        }
        const res = await axiosGet(deleteUserUrl, mapdata,headers);

        dispatch({
            type: DELETE_USER_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const suspendUser_action = (user_id) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: user_id,
            modified_by_id: parseInt(sessionStorage.getItem('user_id')),
            modified_by_user: sessionStorage.getItem('user_name')
        }
        const res = await axiosGet(suspendUserUrl, mapdata,headers);

        dispatch({
            type: SUSPEND_USER_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};